import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardTitle, Row, Col, Badge, Table } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ItemService from "../../../Services/QRCodeServices/MenuItem/ItemService";
import ImageComponent from "../../../Components/Common/ImageComponent";
import NumberCommas from "../../../Components/NumberCommas/NumberCommas";

const MenuItemDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDetail = async () => {
    try {
      const response = await ItemService.detail(id);
      setData(response);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching menu item details:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!data) {
    return <div className="text-center mt-5">No menu item found</div>;
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Menu Item"
          title="Menu Item Detail"
          breadcrumbItems={[{ title: "Back To List ", link: "/menu-item" }]}
        />

        <Card className="shadow-sm">
          <CardBody>
            <Row>
              {/* Image Section */}
              <Col md={4} className="mb-3">
                <Card className="border-0">
                  <img
                    className="img-fluid rounded shadow-sm"
                    src={
                      data?.cloudR2ImagePath?.getCDNUrl() ||
                      "/default-image.png"
                    }
                    alt={data?.title}
                    style={{
                      height: "300px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Card>
              </Col>

              {/* Item Details Section */}
              <Col md={8}>
                <CardTitle tag="h2" className="mb-4 text-primary">
                  {data?.title}
                </CardTitle>

                <Row>
                  <Col md={6} className="mb-3">
                    <h5 className="text-muted">Price</h5>
                    <h4 className="fw-bold">
                      <Badge color="light" className="text-dark">
                        <NumberCommas number={data?.price}/>
                      </Badge>
                    </h4>
                  </Col>
                  <Col md={6} className="mb-3">
                    <h5 className="text-muted">Recipe Price</h5>
                    <h4 className="fw-bold">
                      <Badge color="light" className="text-dark">
                        <NumberCommas number={data?.recipePrice} />
                      </Badge>
                    </h4>
                  </Col>
                </Row>

                <hr />

                <Row>
                  <Col md={6} className="mb-3">
                    <h5 className="text-muted">Actual Food Cost (FC)</h5>
                    <p>
                      <NumberCommas number={data?.profitMargin} />
                    </p>
                  </Col>
                </Row>

                <div className="mb-3">
                  <h5 className="text-muted">Description</h5>
                  <p>{data?.description || "No description available"}</p>
                </div>
              </Col>
            </Row>

            {/* Menu Attributes Section */}
            {data?.menuAttributes && data.menuAttributes.length > 0 && (
              <Card className="mt-4 border-light">
                <CardBody>
                  <h4 className="text-primary mb-3">Menu Attributes</h4>
                  <Table responsive striped hover>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.menuAttributes.map((attr) => (
                        <tr key={attr.id}>
                          <td>{attr.name}</td>
                          <td>
                            <Badge color="info">
                              {Number(attr.rate).toFixed(2)}
                            </Badge>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default MenuItemDetail;
